import type { Dispatch, FC, SetStateAction } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { ModalControlled2, ModalDivider } from "@/ui2/molecules/Modal";

type CancellationModalProps = {
  isModalOpen: boolean;
  SecondaryCTA: FC;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
};

export function CancellationModal({
  isModalOpen,
  SecondaryCTA,
  setIsModalOpen,
}: CancellationModalProps) {
  return (
    <ModalControlled2
      isOpen={isModalOpen}
      onOpenChange={setIsModalOpen}
      title="Leave without finishing?"
    >
      <p className="body-md tw:text-text-secondary">Your progress will be lost if you leave now.</p>

      <ModalDivider />

      <div className="tw:flex tw:justify-end tw:gap-x-3">
        <SecondaryCTA />

        <Button2 onPress={() => setIsModalOpen(false)} size="md" variant="primary">
          Continue
        </Button2>
      </div>
    </ModalControlled2>
  );
}
